import type { ReactElement } from 'react'

import Avatar from '../Avatar'

import { useUserDetailsQuery } from '~/queries/users'

interface Props {
  userId: string
}

const AvatarWithCall = ({ userId }: Props): ReactElement => {
  const { data: user } = useUserDetailsQuery(userId)

  return (
    <div title={user?.name}>
      <Avatar pictureUrl={user?.picture} />
    </div>
  )
}

export default AvatarWithCall
